import React from "react";
import FormTextTC from "../../../components/Forms/FormTextTC";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";

function Piggy() {
  return (
    <>
      <FormTextTC
        name={"pay_provider_sec__piggy__client_id"}
        tDefault={"client id"}
        tKey={"form.primairbetallingsverkeer.label.pay_provider_sec__piggy__client_id"}
      />
      <FormTextTC
        name={"pay_provider_sec__piggy__client_secret"}
        tDefault={"client secret"}
        tKey={"form.primairbetallingsverkeer.label.pay_provider_sec__piggy__client_secret"}
      />
      <FormTextTC
        name={"pay_provider_sec__piggy__shop_id"}
        tDefault={"shop id"}
        tKey={"form.primairbetallingsverkeer.label.pay_provider_sec__piggy__shop_id"}
      />
      <FormSwitchTC
        name={"pay_provider_sec__piggy__use_giftcard"}
        tDefault={"Cadeaukaart"}
        tKey={"vestigingen.form.primairbetallingsverkeer.label.pay_provider_sec__piggy__use_giftcard"}
      />
      <FormSwitchTC
        name={"pay_provider_sec__piggy__use_loyalty"}
        tDefault={"Loyalty"}
        tKey={"vestigingen.form.primairbetallingsverkeer.label.pay_provider_sec__piggy__use_loyalty"}
      />
      <FormSwitchTC
        name={"pay_provider_sec__piggy__use_staged_credits"}
        tDefault={"staged credits"}
        tKey={"vestigingen.form.primairbetallingsverkeer.label.pay_provider_sec__piggy__use_staged_credits"}
      />
    </>
  );
}

export default Piggy;
